import type { FC } from "react";
import { isNil } from "lodash";

import { NO_DATA_SIGN } from "app/filters/const";
import { DEFAULT_DECIMAL, FORMATTERS, PERCENTAGE } from "app/common/benchmark/formatters";
import { pureNumberFilter } from "app/filters/numberFilter";

import type { SearchTrafficData } from "../../types";

import {
    Description,
    Title,
    PercentValue,
    ChangeIndicationBadge,
    IndicatorWrapper,
    TitleWrapper,
    Container,
} from "./styledComponents";

interface MetricTitleProps {
    title: string;
    data: SearchTrafficData;
    descriptionText: string;
    granularityText: string;
}

const MAX_PERCENT_CHANGE_THRESHOLD = 500;

const MetricTitle: FC<MetricTitleProps> = ({ title, data, descriptionText, granularityText }) => {
    const rawChange = data?.change ?? 0;
    const isOverLimit = rawChange > MAX_PERCENT_CHANGE_THRESHOLD;

    const formattedChange = !isNil(data?.change)
        ? isOverLimit
            ? `> ${pureNumberFilter(MAX_PERCENT_CHANGE_THRESHOLD * 10)}${PERCENTAGE}`
            : `${FORMATTERS.percent(rawChange, DEFAULT_DECIMAL)}${PERCENTAGE}`
        : NO_DATA_SIGN;

    const descriptionValue = data?.description?.formattedValue ?? NO_DATA_SIGN;

    return (
        <Container>
            <TitleWrapper>
                <Title>{title}</Title>
                <IndicatorWrapper>
                    {!isNil(data?.change) ? (
                        <ChangeIndicationBadge
                            isNotChanged={rawChange === 0}
                            isIncreasing={rawChange > 0}
                            changeValue={`${formattedChange} ${granularityText}`}
                        />
                    ) : (
                        NO_DATA_SIGN
                    )}
                </IndicatorWrapper>
            </TitleWrapper>
            <Description>
                <PercentValue>{descriptionValue}</PercentValue>
                <span>{descriptionText}</span>
            </Description>
        </Container>
    );
};

export default MetricTitle;
